/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const UpdateBillingSettingsBody = zod
	.object({
		auto_recharge_enabled: zod.boolean().optional().describe('Enable auto-recharge'),
		auto_recharge_target_usd: zod.string().nullish().describe('Target balance after auto-recharge'),
		auto_recharge_threshold_usd: zod
			.string()
			.nullish()
			.describe('Balance threshold to trigger auto-recharge'),
		hard_limit_usd: zod.string().nullish().describe('Hard spending limit in USD'),
		soft_limit_usd: zod.string().nullish().describe('Soft spending limit in USD')
	})
	.describe('Update billing settings');

export type UpdateBillingSettingsBody = zod.input<typeof UpdateBillingSettingsBody>;
export type UpdateBillingSettingsBodyOutput = zod.output<typeof UpdateBillingSettingsBody>;
